export const STATE_ZIP_CODES = {
  'AL': {
    name: 'Alabama',
    min: "35004",
    max: "36925",
  },
  'AK': {
    name: 'Alaska',
    min: "99501",
    max: "99950",
  },
  'AS': {
    name: 'American Samoa',
    min: "96799",
    max: "96799",
  },
  'AZ': {
    name: 'Arizona',
    min: "85001",
    max: "86556",
  },
  'AR': {
    name: 'Arkansas',
    min: "71601",
    max: "72959",
  },
  'CA': {
    name: 'California',
    min: "90001",
    max: "96162",
  },
  'CO': {
    name: 'Colorado',
    min: "80001",
    max: "81658",
  },
  'CT': {
    name: 'Connecticut',
    min: "06001",
    max: "06928",
  },
  'DE': {
    name: 'Delaware',
    min: "19701",
    max: "19980",
  },
  'FL': {
    name: 'Florida',
    min: "32003",
    max: "34997",
  },
  'GA': {
    name: 'Georgia',
    min: "30002",
    max: "39901",
  },
  'HI': {
    name: 'Hawaii',
    min: "96701",
    max: "96898",
  },
  'ID': {
    name: 'Idaho',
    min: "83201",
    max: "83888",
  },
  'IL': {
    name: 'Illinois',
    min: "60001",
    max: "62999",
  },
  'IN': {
    name: 'Indiana',
    min: "46001",
    max: "47997",
  },
  'IA': {
    name: 'Iowa',
    min: "50001",
    max: "52809",
  },
  'KS': {
    name: 'Kansas',
    min: "66002",
    max: "67954",
  },
  'KY': {
    name: 'Kentucky',
    min: "40003",
    max: "42788",
  },
  'LA': {
    name: 'Louisiana',
    min: "70001",
    max: "71497",
  },
  'ME': {
    name: 'Maine',
    min: "03901",
    max: "04992",
  },
  'MD': {
    name: 'Maryland',
    min: "20601",
    max: "21930",
  },
  'MA': {
    name: 'Massachusetts',
    min: "01001",
    max: "05544",
  },
  'MI': {
    name: 'Michigan',
    min: "48001",
    max: "49971",
  },
  'MN': {
    name: 'Minnesota',
    min: "55001",
    max: "56763",
  },
  'MS': {
    name: 'Mississippi',
    min: "38601",
    max: "39776",
  },
  'MO': {
    name: 'Missouri',
    min: "63001",
    max: "65899",
  },
  'MT': {
    name: 'Montana',
    min: "59001",
    max: "59937",
  },
  'NE': {
    name: 'Nebraska',
    min: "68001",
    max: "69367",
  },
  'NV': {
    name: 'Nevada',
    min: "88901",
    max: "89883",
  },
  'NH': {
    name: 'New Hampshire',
    min: "03031",
    max: "03897",
  },
  'NJ': {
    name: 'New Jersey',
    min: "07001",
    max: "08989",
  },
  'NM': {
    name: 'New Mexico',
    min: "87001",
    max: "88441",
  },
  'NY': {
    name: 'New York',
    min: "00501",
    max: "14925",
  },
  'NC': {
    name: 'North Carolina',
    min: "27006",
    max: "28909",
  },
  'ND': {
    name: 'North Dakota',
    min: "58001",
    max: "58856",
  },
  'OH': {
    name: 'Ohio',
    min: "43001",
    max: "45999",
  },
  'OK': {
    name: 'Oklahoma',
    min: "73001",
    max: "74966",
  },
  'OR': {
    name: 'Oregon',
    min: "97001",
    max: "97920",
  },
  'PA': {
    name: 'Pennsylvania',
    min: "15001",
    max: "19640",
  },
  'RI': {
    name: 'Rhode Island',
    min: "02801",
    max: "02940",
  },
  'SC': {
    name: 'South Carolina',
    min: "29001",
    max: "29945",
  },
  'SD': {
    name: 'South Dakota',
    min: "57001",
    max: "57799",
  },
  'TN': {
    name: 'Tennessee',
    min: "37010",
    max: "38589",
  },
  'TX': {
    name: 'Texas',
    min: "73301",
    max: "88595",
  },
  'UT': {
    name: 'Utah',
    min: "84001",
    max: "84791",
  },
  'VT': {
    name: 'Vermont',
    min: "05001",
    max: "05907",
  },
  'VA': {
    name: 'Virginia',
    min: "20101",
    max: "24658",
  },
  'WA': {
    name: 'Washington',
    min: "98001",
    max: "99403",
  },
  'WV': {
    name: 'West Virginia',
    min: "24701",
    max: "26886",
  },
  'WI': {
    name: 'Wisconsin',
    min: "53001",
    max: "54990",
  },
  'WY': {
    name: 'Wyoming',
    min: "82001",
    max: "83128",
  },
}

//use this to test all the zip codes above
// const testZipCodeValTwo = () => {
//   let arr = Object.keys(STATE_ZIP_CODES)
//   arr.forEach(stateAbr => {
//     const min = +STATE_ZIP_CODES[stateAbr].min
//     const max = +STATE_ZIP_CODES[stateAbr].max
//     let i = min
//     while (i <= max) {
//       const res = isZipValid(i, stateAbr)
//       if (!res) {
//         console.log(res, stateAbr, i)
//       }
//       i++
//     }
//   })
// }
//includes different versions from license scans and IIN_Lookup
export const CANADIAN_PROVINCES = [
  'AB', 'BC', 'MB', 'NB',
  'NF', 'NK', 'NL', 'NS',
  'NT', 'NU', 'ON', 'PE',
  'PQ', 'QC', 'SK', 'SN', 'YT',
]

// some pass cases - mainly testing leading zeroes and the Canadian provinces
// let pass = [
//   {
//     zip: "05401",
//     state: 'VT'
//   },
//   {
//     zip: "04074",
//     state: 'ME'
//   },
//   {
//     zip: "",
//     state: 'AB'
//   },
//   {
//     zip: "",
//     state: 'BC'
//   },
//   {
//     zip: "",
//     state: 'MB'
//   },
//   {
//     zip: "",
//     state: 'NB'
//   },
//   {
//     zip: "",
//     state: 'NF'
//   },
//   {
//     zip: "",
//     state: 'NK'
//   },
//   {
//     zip: "",
//     state: 'NL'
//   },
//   {
//     zip: "",
//     state: 'NS'
//   },
//   {
//     zip: "",
//     state: 'NT'
//   },
//   {
//     zip: "",
//     state: 'NU'
//   },
//   {
//     zip: "",
//     state: 'ON'
//   },
//   {
//     zip: "",
//     state: 'PE'
//   },
//   {
//     zip: "",
//     state: 'PQ'
//   },
//   {
//     zip: "",
//     state: 'SK'
//   },
//   {
//     zip: "",
//     state: 'SN'
//   },
//   {
//     zip: "",
//     state: 'YT'
//   },
// ]

// fail cases for each state
// let fail = [
//   { state: 'AL', zip: "" },
//   { state: 'AK', zip: "" },
//   { state: 'AS', zip: "" },
//   { state: 'AZ', zip: "" },
//   { state: 'AR', zip: "" },
//   { state: 'CA', zip: "" },
//   { state: 'CO', zip: "" },
//   { state: 'CT', zip: "" },
//   { state: 'DE', zip: "" },
//   { state: 'FL', zip: "" },
//   { state: 'GA', zip: "" },
//   { state: 'HI', zip: "" },
//   { state: 'ID', zip: "" },
//   { state: 'IL', zip: "" },
//   { state: 'IN', zip: "" },
//   { state: 'IA', zip: "" },
//   { state: 'KS', zip: "" },
//   { state: 'KY', zip: "" },
//   { state: 'LA', zip: "" },
//   { state: 'ME', zip: "" },
//   { state: 'MD', zip: "" },
//   { state: 'MA', zip: "" },
//   { state: 'MI', zip: "" },
//   { state: 'MN', zip: "" },
//   { state: 'MS', zip: "" },
//   { state: 'MO', zip: "" },
//   { state: 'MT', zip: "" },
//   { state: 'NE', zip: "" },
//   { state: 'NV', zip: "" },
//   { state: 'NH', zip: "" },
//   { state: 'NJ', zip: "" },
//   { state: 'NM', zip: "" },
//   { state: 'NY', zip: "" },
//   { state: 'NC', zip: "" },
//   { state: 'ND', zip: "" },
//   { state: 'OH', zip: "" },
//   { state: 'OK', zip: "" },
//   { state: 'OR', zip: "" },
//   { state: 'PA', zip: "" },
//   { state: 'RI', zip: "" },
//   { state: 'SC', zip: "" },
//   { state: 'SD', zip: "" },
//   { state: 'TN', zip: "" },
//   { state: 'TX', zip: "" },
//   { state: 'UT', zip: "" },
//   { state: 'VT', zip: "" },
//   { state: 'VA', zip: "" },
//   { state: 'WA', zip: "" },
//   { state: 'WV', zip: "" },
//   { state: 'WI', zip: "" },
//   { state: 'WY', zip: "" },
//   { state: 'AL', zip: "123456" },
//   { state: 'AL', zip: "000000" },
//   { state: 'AK', zip: "123456" },
//   { state: 'AK', zip: "000000" },
//   { state: 'AS', zip: "123456" },
//   { state: 'AS', zip: "000000" },
//   { state: 'AZ', zip: "123456" },
//   { state: 'AZ', zip: "000000" },
//   { state: 'AR', zip: "123456" },
//   { state: 'AR', zip: "000000" },
//   { state: 'CA', zip: "123456" },
//   { state: 'CA', zip: "000000" },
//   { state: 'CO', zip: "123456" },
//   { state: 'CO', zip: "000000" },
//   { state: 'CT', zip: "123456" },
//   { state: 'CT', zip: "000000" },
//   { state: 'DE', zip: "123456" },
//   { state: 'DE', zip: "000000" },
//   { state: 'FL', zip: "123456" },
//   { state: 'FL', zip: "000000" },
//   { state: 'GA', zip: "123456" },
//   { state: 'GA', zip: "000000" },
//   { state: 'HI', zip: "123456" },
//   { state: 'HI', zip: "000000" },
//   { state: 'ID', zip: "123456" },
//   { state: 'ID', zip: "000000" },
//   { state: 'IL', zip: "123456" },
//   { state: 'IL', zip: "000000" },
//   { state: 'IN', zip: "123456" },
//   { state: 'IN', zip: "000000" },
//   { state: 'IA', zip: "123456" },
//   { state: 'IA', zip: "000000" },
//   { state: 'KS', zip: "123456" },
//   { state: 'KS', zip: "000000" },
//   { state: 'KY', zip: "123456" },
//   { state: 'KY', zip: "000000" },
//   { state: 'LA', zip: "123456" },
//   { state: 'LA', zip: "000000" },
//   { state: 'ME', zip: "123456" },
//   { state: 'ME', zip: "000000" },
//   { state: 'MD', zip: "123456" },
//   { state: 'MD', zip: "000000" },
//   { state: 'MA', zip: "123456" },
//   { state: 'MA', zip: "000000" },
//   { state: 'MI', zip: "123456" },
//   { state: 'MI', zip: "000000" },
//   { state: 'MN', zip: "123456" },
//   { state: 'MN', zip: "000000" },
//   { state: 'MS', zip: "123456" },
//   { state: 'MS', zip: "000000" },
//   { state: 'MO', zip: "123456" },
//   { state: 'MO', zip: "000000" },
//   { state: 'MT', zip: "123456" },
//   { state: 'MT', zip: "000000" },
//   { state: 'NE', zip: "123456" },
//   { state: 'NE', zip: "000000" },
//   { state: 'NV', zip: "123456" },
//   { state: 'NV', zip: "000000" },
//   { state: 'NH', zip: "123456" },
//   { state: 'NH', zip: "000000" },
//   { state: 'NJ', zip: "123456" },
//   { state: 'NJ', zip: "000000" },
//   { state: 'NM', zip: "123456" },
//   { state: 'NM', zip: "000000" },
//   { state: 'NY', zip: "123456" },
//   { state: 'NY', zip: "000000" },
//   { state: 'NC', zip: "123456" },
//   { state: 'NC', zip: "000000" },
//   { state: 'ND', zip: "123456" },
//   { state: 'ND', zip: "000000" },
//   { state: 'OH', zip: "123456" },
//   { state: 'OH', zip: "000000" },
//   { state: 'OK', zip: "123456" },
//   { state: 'OK', zip: "000000" },
//   { state: 'OR', zip: "123456" },
//   { state: 'OR', zip: "000000" },
//   { state: 'PA', zip: "123456" },
//   { state: 'PA', zip: "000000" },
//   { state: 'RI', zip: "123456" },
//   { state: 'RI', zip: "000000" },
//   { state: 'SC', zip: "123456" },
//   { state: 'SC', zip: "000000" },
//   { state: 'SD', zip: "123456" },
//   { state: 'SD', zip: "000000" },
//   { state: 'TN', zip: "123456" },
//   { state: 'TN', zip: "000000" },
//   { state: 'TX', zip: "123456" },
//   { state: 'TX', zip: "000000" },
//   { state: 'UT', zip: "123456" },
//   { state: 'UT', zip: "000000" },
//   { state: 'VT', zip: "123456" },
//   { state: 'VT', zip: "000000" },
//   { state: 'VA', zip: "123456" },
//   { state: 'VA', zip: "000000" },
//   { state: 'WA', zip: "123456" },
//   { state: 'WA', zip: "000000" },
//   { state: 'WV', zip: "123456" },
//   { state: 'WV', zip: "000000" },
//   { state: 'WI', zip: "123456" },
//   { state: 'WI', zip: "000000" },
//   { state: 'WY', zip: "123456" },
//   { state: 'WY', zip: "000000" },
// ]
